import styled from 'styled-components';
import { LabelRegularM } from '../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../styles/theme';


export const HeaderCont = styled.div`
  height: 145px;
  display: flex;
  padding: 0 16px 14px 14px;
  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[5]};
 `}

  &.sticky {
    position: sticky;
    top: 0;
    z-index: 1;
  }
`;

export const GroupInfoHeader = styled.div`
  display: flex;
  width: fit-content;
  flex: 1;
`;


interface IColumnName {
  theme: ITheme;
  sortActive?: boolean;
}
export const ColumnName = styled(LabelRegularM)<IColumnName>`
  transform: rotate(-45deg);
  display: inline-block;
  height: fit-content;
  transform-origin: bottom left;
  margin: 0 0 0 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${({theme, sortActive}: IColumnName) => `
    color: ${theme.colors.neutral.primary[100]};
    font-weight: ${sortActive ? '700' : '400'};
  `}
`;

export const ColumnNameCont = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-end;
`;

export const TeamHeader = styled(ColumnNameCont)`
  justify-self: flex-start;
  margin: 0 auto 0 0;

  ${({theme}: IThemeProvider) => `
    @media ${theme.layout.breakpoints.min.desktop} {
      min-width: 240px;
    }
    @media ${theme.layout.breakpoints.max.desktop} {
      min-width: 110px;
    }
  `}
`;

export const ResponseRateHeader = styled(ColumnNameCont)`
  ${({theme}: IThemeProvider) => `
    @media ${theme.layout.breakpoints.min.desktop} {
      width: 114px;
      margin: 0 5px 0 0;
    }
    @media ${theme.layout.breakpoints.max.desktop} {
      width: 102px;
      margin: 0 10px 0 0;
    }
  `}
`;

export const RiskHeader = styled(ColumnNameCont)`
  width: 88px;
  display: flex;
  justify-content: center;
  margin: 0 60px 0 0;

  ${({theme}: IThemeProvider) => `
    @media ${theme.layout.breakpoints.min.desktop} {
      margin: 0 40px 0 0;
    }
    @media ${theme.layout.breakpoints.max.desktop} {
      margin: 0 12px 0 0;
    }
  `}
`;

export const KpiHeader = styled(ColumnNameCont)`

  ${({theme}: IThemeProvider) => `
    @media ${theme.layout.breakpoints.min.desktop} {
      width: 48px;
      margin: 0 30px 0 0;
    }
    @media ${theme.layout.breakpoints.max.desktop} {
      margin: 0 24px 0 0;
    }
  `}
`;


interface ICategoryHeader {
  theme: ITheme;
  index: number;
  categoryAmount: number;
}

const getStartPosition = (index: number, categoryAmount: number, containerWidth: number) => {
  const margin = 8;
  if(categoryAmount > 2){
    const categoryPlusMarginWidth = containerWidth / categoryAmount;
    const categoryWidth = categoryPlusMarginWidth - margin;
    return (categoryWidth * index) + (index * 8);
  }
  else {
    const maxCategoryWidth = 152;
    const categorySpace = maxCategoryWidth + margin;
    const amountOfEmptySpace = categoryAmount + 1;
    const emptySpaceWidth = (containerWidth - (categorySpace * categoryAmount)) / amountOfEmptySpace;
    return (emptySpaceWidth * (index + 1)) + (index * maxCategoryWidth) + (index * 8);
  }
};

export const CategoryHeader = styled(ColumnNameCont)<ICategoryHeader>`
  display: flex;
  flex-basis: 152px;
  margin-left: 8px;
  position: absolute;
  ${({index, categoryAmount, theme}: ICategoryHeader) => `
    width: 159px;

    @media ${theme.layout.breakpoints.min.desktop} {
    left: ${getStartPosition(index, categoryAmount, 440)}px;
    }
    @media ${theme.layout.breakpoints.max.desktop} {
    left: ${getStartPosition(index, categoryAmount, 400)}px;
    }
  `}
`;

export const ReportHeader = styled(ColumnNameCont)`
  ${({theme}: IThemeProvider) => `
    @media ${theme.layout.breakpoints.min.desktop} {
      margin-left: 40px;
    }
    @media ${theme.layout.breakpoints.max.desktop} {
      margin-left: 20px;
    }
  `}
`;
